import { useEffect, useState } from "react";
import { navSections } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const desktopLinks = navSections.filter((s) =>
    ["featured", "action", "tv", "classic", "collections", "ranking", "faq"].includes(s.id)
  );

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-movie-2-line text-background-50 text-lg" />
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">
            神马影院
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {desktopLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="h-9 px-3 inline-flex items-center rounded-md text-sm font-label text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#featured"
            className="hidden md:inline-flex items-center gap-2 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line" />
            开始找片
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300/60 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </nav>

      {menuOpen ? (
        <div className="lg:hidden border-t border-background-200/80 bg-background-50 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navSections.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="h-10 px-3 inline-flex items-center rounded-md text-sm font-label text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}